import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/contabilidad/polizas';
import Polizas from './PolizasList';


const ms2p = (state) => {
  return {
    ...state.poliza,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Polizas);